export function buildWaUrl(number, message) {
  if (!number) return null;
  const clean = String(number).replace(/\D/g, '');
  const num = clean.startsWith('91') ? clean : `91${clean}`;
  return `https://wa.me/${num}?text=${encodeURIComponent(message)}`;
}

export const WA_TEMPLATES = {
  reminder: (clientName, returnType, period, dueDate) =>
    `Dear ${clientName},\n\nThis is a reminder from Krishna Uday & Associates.\n\n${returnType} for ${period} is due on ${dueDate}.\n\nPlease share the required documents at earliest.\n\nThank you.\nKrishna Uday & Associates`,

  overdue: (clientName, returnType, period, dueDate, lateFee = '') =>
    `Dear ${clientName},\n\n${returnType} for ${period} was due on ${dueDate}.\n${lateFee ? `Late fee of ₹${lateFee}/day is applicable.\n` : ''}Please contact us immediately.\n\nKrishna Uday & Associates`,

  completion: (clientName, returnType, period, ackNumber = '') =>
    `Dear ${clientName},\n\n${returnType} for ${period} has been filed successfully.${ackNumber ? `\nAcknowledgement: ${ackNumber}` : ''}\n\nFor any queries contact us.\n\nKrishna Uday & Associates`,

  invoice: (clientName, invNumber, amount) =>
    `Dear ${clientName},\n\nInvoice ${invNumber} of ₹${amount} is pending.\n\nPlease arrange payment at earliest.\n\nKrishna Uday & Associates`,
};

export function openWhatsApp(number, message) {
  const url = buildWaUrl(number, message);
  if (!url) { alert('No WhatsApp number available for this client'); return; }
  window.open(url, '_blank');
}
